import { createRouteRef, createSubRouteRef } from '@backstage/core-plugin-api';

export const aiEvalBasePath = '/aievaluation';
export const evaluationsPath = `${aiEvalBasePath}/evaluations`;
export const aboutPath = `${aiEvalBasePath}/about`;
export const teamPath = `${aiEvalBasePath}/team`;
export const changeHistoryPath = `${aiEvalBasePath}/change-history`;
export const onboardToolPath = `${aiEvalBasePath}/onboard`;
export const statisticsPath = `${aiEvalBasePath}/statistics`;

export const rootRouteRef = createRouteRef({
  id: 'aievaluation',
});

export const evaluationsRouteRef = createSubRouteRef({
  id: 'aievaluation.evaluations',
  parent: rootRouteRef,
  path: '/evaluations',
});

export const aboutRouteRef = createSubRouteRef({
  id: 'aievaluation.about',
  parent: rootRouteRef,
  path: '/about',
});

export const onboardToolRouteRef = createSubRouteRef({
  id: 'aievaluation.onboard',
  parent: rootRouteRef,
  path: '/onboard',
});

export const editToolRouteRef = createSubRouteRef({
  id: 'aievaluation.edit',
  parent: rootRouteRef,
  path: '/evaluations/edit/:toolId',
});

export const teamRouteRef = createSubRouteRef({
  id: 'aievaluation.team',
  parent: rootRouteRef,
  path: '/team',
});

export const statisticsRouteRef = createSubRouteRef({
  id: 'aievaluation.statistics',
  parent: rootRouteRef,
  path: '/statistics',
});

export const changeHistoryRouteRef = createSubRouteRef({
  id: 'aievaluation.change-history',
  parent: rootRouteRef,
  path: '/change-history',
});
